// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c204a89","239":"806722f6","455":"9b933bf7"}[chunkId] + ".chunk.js";
};